"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var react_color_1 = require("react-color");
var CardRowColorPickerEditor_1 = require("../../../../../../shared/components/editors/CardRowColorPickerEditor");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var CfgTrustZoneEditor = /** @class */ (function (_super) {
    __extends(CfgTrustZoneEditor, _super);
    function CfgTrustZoneEditor(props) {
        return _super.call(this, props) || this;
    }
    CfgTrustZoneEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    zone_code: _item.zone_code,
                    color: _item.color,
                    is_default: _item.is_default,
                    order_number: _item.order_number,
                    description: _item.description,
                    show_picker: false,
                    is_prohibit_dep_bonuses: _item.is_prohibit_dep_bonuses,
                    is_prohibit_nodep_bonuses: _item.is_prohibit_nodep_bonuses,
                    is_prohibit_tournaments: _item.is_prohibit_tournaments,
                    is_prohibit_cashback_bonuses: _item.is_prohibit_cashback_bonuses,
                    is_prohibit_jackpots: _item.is_prohibit_jackpots,
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование зоны доверия"]);
                });
            }
        }
        else {
            this.setState({
                title: "",
                zone_code: 0,
                color: "#FF0000",
                is_default: false,
                order_number: 0,
                description: "",
                show_picker: false,
                is_prohibit_dep_bonuses: false,
                is_prohibit_nodep_bonuses: false,
                is_prohibit_tournaments: false,
                is_prohibit_cashback_bonuses: false,
                is_prohibit_jackpots: false,
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание зоны доверия"]);
            });
        }
        this.doReSetRules();
    };
    CfgTrustZoneEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            zone_code_rules: { isError: false },
            color_rules: { isError: false },
            order_number_rules: { isError: false },
        });
    };
    CfgTrustZoneEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                zone_code: this.state.zone_code,
                order_number: this.state.order_number,
                description: this.state.description,
                title: this.state.title,
                is_default: this.state.is_default,
                color: this.state.color,
                is_prohibit_dep_bonuses: this.state.is_prohibit_dep_bonuses,
                is_prohibit_nodep_bonuses: this.state.is_prohibit_nodep_bonuses,
                is_prohibit_tournaments: this.state.is_prohibit_tournaments,
                is_prohibit_cashback_bonuses: this.state.is_prohibit_cashback_bonuses,
                is_prohibit_jackpots: this.state.is_prohibit_jackpots,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Зона доверия изменена!");
            });
        }
    };
    CfgTrustZoneEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        if ((this.state.zone_code <= 0) || (this.state.zone_code > 100)) {
            this.setState({ zone_code_rules: { isError: true, errorMessage: "Поле [код] не заполнено!" } });
            return false;
        }
        if ((!this.state.color) || (this.state.color.length !== 7)) {
            this.setState({ color_rules: { isError: true, errorMessage: "Поле [цвет] имеет некорректное значение!" } });
            return false;
        }
        if ((this.state.order_number <= 0) || (this.state.order_number > 100)) {
            this.setState({ order_number_rules: { isError: true, errorMessage: "Поле [номер п/п] имеет некорректное значение!" } });
            return false;
        }
        return true;
    };
    CfgTrustZoneEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                zone_code: this.state.zone_code,
                order_number: this.state.order_number,
                description: this.state.description,
                title: this.state.title,
                is_default: this.state.is_default,
                color: this.state.color,
                is_prohibit_dep_bonuses: this.state.is_prohibit_dep_bonuses,
                is_prohibit_nodep_bonuses: this.state.is_prohibit_nodep_bonuses,
                is_prohibit_tournaments: this.state.is_prohibit_tournaments,
                is_prohibit_cashback_bonuses: this.state.is_prohibit_cashback_bonuses,
                is_prohibit_jackpots: this.state.is_prohibit_jackpots,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Зона доверия добавлена!");
            });
        }
    };
    CfgTrustZoneEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    CfgTrustZoneEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить зону доверия";
        }
        else {
            return "Изменить зону доверия";
        }
    };
    CfgTrustZoneEditor.prototype.handleClose = function () {
        this.setState({ show_picker: false });
    };
    CfgTrustZoneEditor.prototype.getColorPicker = function () {
        if (this.state.show_picker) {
            return (React.createElement("div", { style: { position: 'absolute', zIndex: 2, } },
                React.createElement("div", { style: {
                        position: 'fixed',
                        top: '0px',
                        right: '0px',
                        bottom: '0px',
                        left: '0px',
                    }, onClick: this.handleClose.bind(this) }),
                React.createElement(react_color_1.ChromePicker, null)));
        }
    };
    CfgTrustZoneEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 700 },
            this.getColorPicker(),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название зоны:", placeholder: "Введите название зоны" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Код зоны:",
                    placeholder: "Введите код зоны"
                }, values: {
                    max: 999999,
                    min: 1,
                    value: this.state.zone_code
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        zone_code: newVal,
                        zone_code_rules: { isError: false }
                    });
                }, required: true, rules: this.state.zone_code_rules }),
            React.createElement(CardRowColorPickerEditor_1.default, { texts: { caption: "Цвет зоны:", placeholder: "Выберите цвет зоны", buttonHint: "Выберите цвет" }, color: this.state.color, onColorChanged: function (newVal) {
                    _this.setState({
                        color: newVal,
                        color_rules: { isError: false }
                    });
                }, required: true, rules: this.state.color_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Номер П/П:",
                    placeholder: "Введите номер по порядку"
                }, values: {
                    max: 999999,
                    min: 1,
                    value: this.state.order_number
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        order_number: newVal,
                        order_number_rules: { isError: false }
                    });
                }, required: true, rules: this.state.order_number_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Запретить депозитные бонусы", value: this.state.is_prohibit_dep_bonuses, onChecked: function (checked) {
                    _this.setState({
                        is_prohibit_dep_bonuses: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Запретить бездепозитные бонусы", value: this.state.is_prohibit_nodep_bonuses, onChecked: function (checked) {
                    _this.setState({
                        is_prohibit_nodep_bonuses: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Запретить турниры", value: this.state.is_prohibit_tournaments, onChecked: function (checked) {
                    _this.setState({
                        is_prohibit_tournaments: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Запретить кэшбеки", value: this.state.is_prohibit_cashback_bonuses, onChecked: function (checked) {
                    _this.setState({
                        is_prohibit_cashback_bonuses: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Запретить джекпоты", value: this.state.is_prohibit_jackpots, onChecked: function (checked) {
                    _this.setState({
                        is_prohibit_jackpots: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Зона доверия по-умолчанию", value: this.state.is_default, onChecked: function (checked) {
                    _this.setState({
                        is_default: checked
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return CfgTrustZoneEditor;
}(React.Component));
exports.default = CfgTrustZoneEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_trust_zones/ui/component/CfgTrustZoneEditor.tsx
// module id = 2579
// module chunks = 0